import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/Child-Student-Visa.png";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaCheckCircle, FaClock, FaChild, FaHome, FaGraduationCap, FaUsers, FaHeart, FaShieldAlt, FaFileAlt, FaCalendarAlt, FaMapMarkedAlt, FaPassport, FaUserCheck, FaBaby, FaHandHoldingHeart } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import applicationProcess from "../../images/individual/application-proccess.svg";
import { Helmet } from "react-helmet-async";

const ChildVisa = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Testimonials data for this specific page
  const testimonials = [
    {
      content: "Immiget helped bring my daughter from India in just 14 months!",
      name: "Anika",
      location: "Sydney",
      visaType: "Child Visa (Subclass 101)"
    },
    {
      content: "After our adoption in Thailand, the Subclass 102 visa process was seamless.",
      name: "David & Mark",
      location: "Melbourne",
      visaType: "Adoption Visa (Subclass 102)"
    }
  ];

  const faqs = [
    {
      question: "Can I include my child in my own visa application?",
      answer: "Yes, if applying for a partner or skilled visa, children can be added as dependents."
    },
    {
      question: "What if my child is over 18?",
      answer: "They may qualify if financially dependent due to disability or full-time study."
    },
    {
      question: "Does the child need to take English tests?",
      answer: "No, English tests are not required for child visas."
    },
    {
      question: "Can my child work on this visa?",
      answer: "Yes, permanent residency grants full work rights."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Child Visa Australia (Subclass 101, 102 & 802) – Reunite Your Family - Immiget Global</title>
        <meta
          name="description"
          content="Bring your child to Australia permanently with Child Visa (Subclass 101, 102 & 802). Expert family visa assistance. High approval rate. Reunite your family today."
        />
        <meta 
          name="keywords" 
          content="child visa australia, subclass 101, subclass 102, subclass 802, adoption visa, family reunion, child permanent residency" 
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Child Visas (Subclass 101, 102 & 802)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Family & Spouse
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Child Visas
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[28px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            Child Visa Australia (Subclass 101, 102 & 802) – Reunite Your Family
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-xl font-normal">
            Want to bring your child to Australia permanently? The Child Visa (Subclass 101, 102 & 802) allows parents to sponsor their dependent children for Australian permanent residency (PR). At Immiget Global, we specialize in family visa applications, ensuring a smooth and successful process for your child's relocation.
          </p>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Child Visa" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Types of Australian Child Visas */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Types of Australian Child Visas
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          {/* Subclass 101 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Subclass 101 (Child Visa – Outside Australia)
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-4">
                For biological, adopted, or stepchildren of Australian citizens, PR holders, or eligible NZ citizens living in Australia.
              </p>
              <h4 className="text-blue text-lg font-semibold hellix-font mb-3 flex items-center gap-2">
                <FaCheckCircle className="text-green-500" />
                Requirements:
              </h4>
              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Child must be under 18 (or up to 25 if full-time student)</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Parent must meet Australian residency status</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Child must be dependent (not married/in a de facto relationship)</span>
                </div>
              </div>
              <div className="bg-blue-50 p-3 rounded-lg">
                <p className="text-blue hellix-font">
                  📌 <strong>Processing Time:</strong> 12-24 months
                </p>
              </div>
            </div>
          </div>

          {/* Subclass 802 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-green-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Subclass 802 (Child Visa – Inside Australia)
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-4">
                For children already in Australia on a valid visa who meet dependency criteria.
              </p>
              <h4 className="text-blue text-lg font-semibold hellix-font mb-3 flex items-center gap-2">
                <FaCheckCircle className="text-green-500" />
                Requirements:
              </h4>
              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Child must be in Australia on a substantive visa</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Meet same dependency rules as Subclass 101</span>
                </div>
              </div>
              <div className="bg-green-50 p-3 rounded-lg">
                <p className="text-blue hellix-font">
                  📌 <strong>Processing Time:</strong> 12-18 months
                </p>
              </div>
            </div>
          </div>

          {/* Subclass 102 */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-purple-600 text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Subclass 102 (Adoption Visa)
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font mb-4">
                For children adopted overseas by Australian citizens/PR holders through formal adoption processes.
              </p>
              <h4 className="text-blue text-lg font-semibold hellix-font mb-3 flex items-center gap-2">
                <FaCheckCircle className="text-green-500" />
                Requirements:
              </h4>
              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Adoption must be legal in home country & Australia</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaCheckCircle className="text-green-500 text-sm" />
                  <span className="text-blue hellix-font">Child must be under 18</span>
                </div>
              </div>
              <div className="bg-purple-50 p-3 rounded-lg">
                <p className="text-blue hellix-font">
                  📌 <strong>Processing Time:</strong> 18-30 months
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Key Benefits */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className=" text-2xl text-blue font-semibold hellix-font">
            Key Benefits of Child Visas
          </h1>
        </div>
        
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaHome className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Permanent residency for your child
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaShieldAlt className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Access to Medicare & schooling
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaUserCheck className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font px-4">
              ✅ Pathway to citizenship (after residency period)
            </div>
          </div>
        </div>
        <div className="flex gap-8 justify-center flex-wrap mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <FaUsers className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg font-normal max-md:px-2 text-center hellix-font">
              ✅ No sponsorship limits (unlike parent visas)
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How to Apply */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={applicationProcess} alt="Application Process" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            How to Apply for a Child Visa
          </h1>
        </div>
        
        <div className="mt-6 space-y-6">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Check Eligibility
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Confirm child meets age & dependency rules</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Ensure sponsor meets residency requirements</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Gather Documents
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Child's birth certificate/passport</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Proof of parent's Australian status</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Evidence of dependency (school records, medical needs)</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Adoption papers (if applicable)</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Lodge Application
              </h3>
            </div>
            <div className="ml-16 space-y-2">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Subclass 101/102: Apply online while child is outside Australia</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-blue rounded-full"></span>
                <span className="text-blue hellix-font">Subclass 802: Apply online while child is inside Australia</span>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">4</span>
              </div>
              <h3 className="text-blue text-xl font-semibold hellix-font">
                Wait for Processing
              </h3>
            </div>
            <div className="ml-16">
              <p className="text-blue hellix-font">May require medical checks & biometrics</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaCheckCircle className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              🔹 High Approval Rate – Expert handling of complex cases
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaClock className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              🔹 Fast Processing – Avoid delays with accurate submissions
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaHandHoldingHeart className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              🔹 Special Needs Cases Support – For children with disabilities
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-full h-[206px] p-4">
            <div>
              <FaGraduationCap className="text-blue text-4xl" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              🔹 Post-Visa Assistance – Schooling & healthcare guidance
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
            Reunite Your Family Today!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            📞 Book a free consultation with our child visa experts.
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Get Free Consultation
          </button>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className=" text-3xl text-center text-blue font-semibold hellix-font">
          FAQs
        </h1>
        <p className="text-blue font-normal text-xl lg:text-[22px] text-center hellix-font">
          Get answers to common questions about Child Visas.
        </p>

        <div className="accordion-container mt-8">
          {faqs.map((faq, index) => (
            <div key={index} className="accordion mt-2">
              <div
                className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
                onClick={() => toggleAccordion(index)}
              >
                <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                  ❓ {faq.question}
                </h2>
                {activeIndex === index ? <FaTimes /> : <FaPlus />}
              </div>
              {activeIndex === index && (
                <div className="accordion-content p-4">
                  <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Section */}
      <Testimonials 
        testimonials={testimonials} 
        title="Success Stories"
      />

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[28px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced family visa specialists understand the emotional importance of reuniting families. We provide comprehensive support throughout the child visa process, from initial eligibility assessment to final approval. With our expertise in complex cases and attention to detail, we ensure your child's visa application is processed smoothly and efficiently.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default ChildVisa;